import { SamplingPointStation } from "../types/samplingPointStation.type";
import { responseHandlerDefault } from "@/utils/handler.util";
import axios from "./api";

/**
 * Obtener la lista que relaciona los puntos con las estaciones
 * @param code
 * @returns
 */
export const getSamplingPointStation = async (code: string): Promise<SamplingPointStation[]> => {
  const params: { code?: string } = {};
  params.code = code;
  return axios.get(`/samplingpoint-station?`, { params }).then(responseHandlerDefault);
};

export const postSamplingPointStation = async (
  samplingPointStation: SamplingPointStation
): Promise<SamplingPointStation> => {
  return axios
    .post(`/samplingpoint-station/`, { samplingPointStation })
    .then(responseHandlerDefault);
};

export const getNewName = (code: string): Promise<string> => {
  const params: { code?: string } = {};
  params.code = code;
  return axios
    .get<string>(`/samplingpoint-station/newname`, { params })
    .then(responseHandlerDefault);
};
